import { Controller } from "@hotwired/stimulus"

// Confirms a branch switch when the customer has items in their cart.
// Attached to the location modal's form. Reads:
//   - current_branch_id (the branch the cart is currently tied to)
//   - has_items (boolean — does the current cart have line items?)
// When the user submits the form, if they selected a DIFFERENT branch and
// the current cart has items, we prompt before allowing the submission.
export default class extends Controller {
  static values = { currentBranchId: Number, hasItems: Boolean }

  check(event) {
    if (!this.hasItemsValue) return
    if (!this.currentBranchIdValue) return

    const selected = this.element.querySelector('input[name="restaurant_branch_fulfillment_mode_id"]:checked')
    if (!selected) return

    const newBranchId = Number(selected.dataset.branchId)
    if (newBranchId === this.currentBranchIdValue) return

    const confirmed = window.confirm(
      "Switching to a different location will leave your current cart behind. Continue?"
    )
    if (!confirmed) {
      event.preventDefault()
      event.stopImmediatePropagation()
    }
  }
}
